import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RefWindowService } from '../../common-services/ref-window.service';
import { AuthenticationService } from '../auth/auth.service';
import { AppSettings } from '../../app.settings';

@Component({
  selector: 'app-auth-direct',
  templateUrl: './auth-direct.component.html',
  styleUrls: ['./auth-direct.component.css']
})
export class AuthDirectComponent implements OnInit {

	public userEmail: string;

	public imgUrl: string = AppSettings.authLogoUrl;

	constructor(
		private router: Router,
		private authService: AuthenticationService,
		private windowRef: RefWindowService
	) { }

	ngOnInit() {
	}
	async enterEmail() {
		if (!this.userEmail) { return; }
		try {
			const authTypeOutput = await this.authService.getAuthType(this.userEmail);
			this.authService.authDirect(authTypeOutput.cusAuth);
		} catch (err) {
			console.log(err);
		}

	}
}



// WEBPACK FOOTER //
// ./src/app/components/auth-direct/auth-direct.component.ts